import React from "react";
import { useNavigate } from "react-router-dom";
import "../LaunchPage.css";

export default function LaunchPage({ setShowLogin }) {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    // Go to homepage
    navigate("/");

    // Trigger login modal once navigation completes
    setTimeout(() => {
      if (setShowLogin) setShowLogin(true);
    }, 0);
  };

  return (
    <main className="launch-page light-theme">
      {/* === HERO === */}
      <section className="launch-hero">
        <div className="launch-hero-content">
          <h1>Finally, clarity in chronic pain care.</h1>
          <p>
            <strong>Horizons</strong> turns <strong>1,000+</strong> research studies and real-world
            outcomes into clear, evidence-based guidance, so you can choose
            treatments with confidence.
          </p>
          <p className="launch-subtext">
           We show you what traditional care leaves out — the benefits, the side effects, 
           and the long-term results of each treatment, all in one simple platform. <br /> <br />
           <span style={{ fontWeight: 600, color: '#123456' }}>
            With <strong>Horizons</strong>, recovery is finally in sight.
          </span>
          </p>

          <div className="launch-hero-buttons">
            <button
              className="launch-primary-btn"
              onClick={() => navigate("/register")}
            >
              Join for Free
            </button>
            <button
              className="launch-secondary-btn"
              onClick={handleLoginClick}
            >
              Log In
            </button>
          </div>
        </div>

        <div className="launch-hero-art">
          <div className="launch-device-frame">
            <img
              src="/horizons-app-preview.png"
              alt="Horizons app preview"
              className="launch-app-screenshot"
            />
          </div>
        </div>
      </section>

      {/* === FEATURES === */}
      <section className="launch-features">
        <h2>Why people choose Horizons</h2>
        <div className="launch-grid">
          <div className="launch-card">
            <h3>Evidence that’s actually usable</h3>
            <p>
              We break complex clinical studies down into plain language, so you can focus on what actually matters for your care.
            </p>
          </div>

          <div className="launch-card">
            <h3>Know benefits and risks upfront</h3>
            <p>
              Understand real outcomes, possible side effects, and recovery timelines — so you know what to expect before you begin.
            </p>
          </div>

          <div className="launch-card">
            <h3>Insights for people like you</h3>
            <p>
              Explore what has helped others with your condition and track what
              works for you over time.
            </p>
          </div>
        </div>
      </section>

      {/* === CTA === */}
      <section className="launch-cta">
        <h2>Make informed choices — with real data behind them.</h2>
        <p>
          Join thousands using Horizons to bring clarity, confidence, and
          evidence into their pain care.
        </p>
        <button
          className="launch-primary-btn light"
          onClick={() => navigate("/register")}
        >
          Create Your Free Account
        </button>
      </section>

      <footer className="launch-footer">
        © 2025 Horizons — Evidence-based guidance for people living with chronic pain.
      </footer>
    </main>
  );
}
